// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1nATk","title":"ClientInsurance_title__19AV0","itemText":"ClientInsurance_itemText__2eIia"};